import React, { useState, createContext, useEffect } from 'react';

const AppContext = createContext();
const { Provider } = AppContext;

const AppProvider = ({ children }) => {
    const [scroll, setScroll] = useState(0);
    const [inArticle, setInArticle] = useState(false);
    const [hasLoadedSession, setSessionLoaded] = useState((sessionStorage.getItem("hasLoaded") == "true"));
    const [loading, setLoading] = useState(false);
    const [loaded, setHasLoaded] = useState(false);

    useEffect(()=> {
        // console.log(loading);
    }, []);

    function toggleArticle() {
        setInArticle(inArticle => !inArticle)
    }
    const state = {
        scroll,
        inArticle,
        loading,
        loaded,
        hasLoadedSession
    };

    const actions = {
        setScroll,
        toggleArticle,
        setInArticle,
        setLoading,
        setHasLoaded,
        setSessionLoaded
    };

    return (
        <Provider value={{ ...state, ...actions }}>
            {children}
        </Provider>
    )

}

export {
    AppContext,
    AppProvider
}
